import {
	backgroundColor,
	colorBase,
	getLabelWidth,
	horizontalGutter,
	lineBorder,
} from 'Components/flowChart/index.style.js';
import styled, { css } from 'styled-components';

export const WrapperPopup = styled.div``;

export const WrapperIcon = styled.div`
	width: 24px;
	height: 24px;
	background-color: #fff;
	border: 1px solid #b8cfe6;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	i {
		color: ${colorBase};
		font-size: 14px;
	}
`;

export const DropSpace = styled.div<{ isDroppable?: boolean }>`
	visibility: hidden;
	position: absolute;
	top: 0px;
	left: 0;
	width: 100%;
	height: 60px;
	z-index: -1;
`;

export const RadioButton = styled.input`
	margin-top: 0.2rem;
	margin-right: 0.5rem;
	cursor: pointer;
`;

export const Label = styled.label`
	display: block;
	font-size: 14px;
	cursor: pointer;
`;

export const DropPlaceholder = styled.div`
	width: 20px;
	height: 20px;
	border-radius: 15px;
	border: ${lineBorder};
	gap: 10px;
	background-color: #f2f9ff;

	position: absolute;
	top: 18px;
	right: 18px;
	z-index: 5;
`;

export const WrapperButton = styled.div<{ isViewMode: boolean; noData?: boolean; isDroppable?: boolean }>`
	width: ${({ isViewMode }) => `calc(${getLabelWidth(isViewMode)} + ${horizontalGutter})`};
	position: relative;
	z-index: 2;
	height: 60px;

	.btn-add {
		top: 17px;
		right: 17px;
		position: absolute;
		cursor: pointer;
		background: none;
		border: none;
		padding: 0;
		background-color: ${backgroundColor};
		z-index: 5;

		&:focus {
			outline: 0;
		}

		&.no-data {
			left: 0;
		}

		> .icon-plus-circle {
			display: block;
		}
	}
	${({ noData, isDroppable }) =>
		noData &&
		css`
			${DropPlaceholder} {
				top: 19px;
				left: 22px;
			}
			${DropSpace} {
				visibility: ${isDroppable ? 'visible' : 'hidden'};
			}
			.btn-add.no-data {
				visibility: ${isDroppable ? 'hidden' : 'visible'};
			}
		`}
	${({ isDroppable }) =>
		isDroppable &&
		css`
			${DropPlaceholder} {
				visibility: visible;
			}
		`}
`;
